module.exports = __webpack_public_path__ + "media/application/images/person-e61dfc784113e170cad2ae5a465ddc99.png";